var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08295 7.61366C5.43669 4.07971 8.41055 1.38867 11.9622 1.38867V1.38867C15.5138 1.38867 18.4876 4.07972 18.8414 7.61367L19.2425 11.6213C19.3094 12.2897 19.3429 12.624 19.4035 12.9515C19.5149 13.5535 19.695 14.1407 19.9404 14.7016C20.0739 15.0068 20.2336 15.3023 20.553 15.8933L21.628 17.8821C22.3398 19.1989 22.6957 19.8573 22.4048 20.3452C22.1139 20.8331 21.3655 20.8331 19.8686 20.8331H4.0557C2.55883 20.8331 1.8104 20.8331 1.51951 20.3452C1.22862 19.8573 1.5845 19.1989 2.29628 17.8821L3.37128 15.8933C3.69073 15.3023 3.85046 15.0068 3.98394 14.7016C4.22927 14.1407 4.40941 13.5535 4.52081 12.9515C4.58143 12.624 4.61488 12.2897 4.68179 11.6213L5.08295 7.61366Z",
    stroke: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3364 21.3968C8.55026 22.4304 9.0215 23.3438 9.67705 23.9952C10.3326 24.6467 11.1358 24.9998 11.9621 24.9998C12.7884 24.9998 13.5916 24.6467 14.2471 23.9952C14.9027 23.3438 15.3739 22.4304 15.5878 21.3968",
    stroke: "#999999",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/BellIcon.b69cd23f0abbe8d3fd9e5e5d8f153a8b.svg";
export { ForwardRef as ReactComponent };